const Module2Config = {
	day1: {
		learn: {
			video: 'Module2Videos/learn_day_1.mp4',
			song: 'appfiles/listening/school_photo_montage_music_1.m4a',
			json: 'appfiles/listening/school_photo_montage_data_1.json',
		},
		celebrate: {
			video: 'Module2Videos/celebrate_day_1.mp4',
		},
		rewardOption2: 'MonkeybarsYellow',
		rewardOption1: 'MonkeybarsBlue',
	},
	day2: {
		learn: {
			video: 'Module2Videos/learn_day_2.mp4',
			song: 'appfiles/listening/school_photo_montage_music_2.m4a',
			json: 'appfiles/listening/school_photo_montage_data_2.json',
		},
		celebrate: {
			video: 'Module2Videos/celebrate_day_2.mp4',
		},
		rewardOption2: 'SlideYellow',
		rewardOption1: 'SlideRed',
	},
	day3: {
		learn: {
			video: 'Module2Videos/learn_day_3.mp4',
			song: 'appfiles/listening/school_photo_montage_music_3.m4a',
			json: 'appfiles/listening/school_photo_montage_data_3.json',
		},
		celebrate: {
			video: 'Module2Videos/celebrate_day_3.mp4',
		},
		rewardOption1: 'Pond',
		rewardOption2: 'Sandbox',
	},
	day4: {
		introVideo: 'Module2Videos/welcome_day_4.mp4',
		rewardOption2: 'KitePink',
		rewardOption1: 'KitePurple',
		photoTime: {
			video1: 'Module2Videos/photo_time_1.mp4',
			video2: 'Module2Videos/photo_time_2.mp4',
		},
		singingTime: {
			intro: 'f63e98b94609f5de3c6fc8392da4/playlist.m3u8',
			demoMusic: '',
			singAlongMusic: 'appfiles/listening/listening_student_singalong.m4a',
			instrumentalMusic:
				'appfiles/listening/listening_student_instrumental.m4a',
			singingAlongVideo: 'appfiles/listening/singingtime_listening_demo.mp4',
			instrumentalVideo: 'appfiles/listening/singingtime_listening_karaoke.mp4',
		},
	},
	day5: {
		introVideo: 'Module2Videos/welcome_day_5.mp4',
		rewardOption1: 'TireSwing',
		rewardOption2: 'SpringToy',
		learn: {
			recording: 'userfiles/{student-id}/listening_play_day_music.m4a',
			video: 'influencers/{influencer-id}/answer_affirmation.mp4',
			song: 'appfiles/listening/listening_student_instrumental.m4a',
			demoSong: 'appfiles/listening/listening_student_singalong.m4a',
			json: 'appfiles/listening/school_photo_montage_data_5.json',
		},
		celebrate: {
			video: 'Module2Videos/celebrate_intro_day_5.mp4',
			afterVideo: 'Module2Videos/celebrate_close_day_5.mp4',
			animal: true,
			text: 'Record yourself in an excited voice and say, "I am amazing!"',
			name: 'listening_celebration_surprise_5.mp4',
		},
	},
	day6: {
		rewardOption2: 'Flowers',
		rewardOption1: 'Ball',
		learn: {
			recording: 'userfiles/{student-id}/listening_play_day_music.m4a',
			video: 'influencers/{influencer-id}/answer_affirmation.mp4',
			song: 'appfiles/listening/listening_student_instrumental.m4a',
			demoSong: 'appfiles/listening/listening_student_singalong.m4a',
			json: 'appfiles/listening/school_photo_montage_data_6.json',
		},
		celebrate: {
			video: 'Module2Videos/celebrate_intro_day_6.mp4',
			afterVideo: 'Module2Videos/celebrate_close_day_6.mp4',
			animal: true,
			text: 'Record yourself in a funny voice and say, "I am amazing!"',
			name: 'listening_celebration_surprise_6.mp4',
		},
	},
	day7: {
		rewardOption2: 'MerryGoRound',
		rewardOption1: 'Swingset',
		learn: {
			recording: 'userfiles/{student-id}/listening_play_day_music.m4a',
			video: 'influencers/{influencer-id}/answer_affirmation.mp4',
			song: 'appfiles/listening/listening_student_instrumental.m4a',
			demoSong: 'appfiles/listening/listening_student_singalong.m4a',
			json: 'appfiles/listening/school_photo_montage_data_7.json',
		},
		celebrate: {
			video: 'Module2Videos/celebrate_intro_day_7.mp4',
			afterVideo: 'Module2Videos/celebrate_close_day_7.mp4',
			animal: true,
			text: 'Record yourself singing, "I am amazing!"',
			name: 'listening_celebration_surprise_7.mp4',
		},
	},
	day8: {
		rewardOption2: 'ButterflyBlue',
		rewardOption1: 'ButterflyPink',
		learn: {
			recording: 'userfiles/{student-id}/listening_play_day_music.m4a',
			video: 'influencers/{influencer-id}/answer_affirmation.mp4',
			song: 'appfiles/listening/listening_student_instrumental.m4a',
			demoSong: 'appfiles/listening/listening_student_singalong.m4a',
			json: 'appfiles/listening/school_photo_montage_data_8.json',
		},
		celebrate: {
			video: 'Module2Videos/celebrate_intro_day_8.mp4',
			afterVideo: 'Module2Videos/celebrate_close_day_8.mp4',
			animal: true,
			text: 'Record yourself making a silly face and say, "I am amazing!"',
			name: 'listening_celebration_surprise_8.mp4',
		},
	},
	day9: {
		conclusionVideo: 'Module2Videos/closing.mp4',
		rewardOption2: 'Hat',
		rewardOption1: 'Bow',
		learn: {
			video: 'influencers/{influencer-id}/answer_affirmation.mp4',
			song: 'appfiles/listening/listening_student_instrumental.m4a',
			recording: 'userfiles/{student-id}/listening_play_day_music.m4a',
			demoSong: 'appfiles/listening/listening_student_singalong.m4a',
			json: 'appfiles/listening/school_photo_montage_data_9.json',
		},
		celebrate: {
			video: 'Module2Videos/celebrate_intro_day_9.mp4',
			afterVideo: null,
			animal: true,
			text: 'Record yourself dancing and say, "I am amazing!"',
			name: 'listening_celebration_surprise_9.mp4',
		},
		surprise: {
			video: 'Module2Videos/surprise.mp4',
			song: 'appfiles/listening/hear_me_instrumental.m4a',
			slides: [
				'influencers/{influencer-id}/answer_affirmation.mp4',
				'userfiles/{student-id}/listening_celebration_surprise_6.mp4',
				'userfiles/{student-id}/listening_photo_1.jpg',
				'influencers/{influencer-id}/listening_video_message.mp4',
				'userfiles/{student-id}/listening_celebration_surprise_8.mp4',
				'userfiles/{student-id}/listening_silly_photo_2.jpg',
				'userfiles/{student-id}/listening_celebration_surprise_9.mp4',
			],
		},
	},
}

export default Module2Config
